import React from "react";
import { Flex } from 'antd';
import "./IngredientList.css";
import IngredientCard from "./IngredientCard";

const IngredientList = (props) => {

    return (
        <div>
            <Flex gap="middle" vertical>
                {props.data.sort((a, b) => a.name.localeCompare(b.name)).map(item => (
                    <IngredientCard key={item.name} name={item.name} amount={item.amount} changeMethod={props.changeMethod} />
                ))
                }
            </Flex>
        </div>
    );
};

export default IngredientList;